import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#6DA544",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M6.781 14.348c0 .864.701 1.565 1.565 1.565h4.696c0 .72.584 1.304 1.305 1.304h1.565c.72 0 1.304-.584 1.304-1.304v-1.565zM17.348 6.783v3.652c0 .575-.468 1.044-1.043 1.044v1.565a2.61 2.61 0 0 0 2.608-2.609V6.783zM6.13 10.435c0 .575-.469 1.043-1.044 1.043v1.566a2.61 2.61 0 0 0 2.609-2.61V6.784H6.129z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M16.565 6.783H15v3.652h1.565zM12.65 8.87a.261.261 0 0 1-.521 0V6.783h-1.565V8.87a.261.261 0 0 1-.522 0V6.783H8.477V8.87c0 1.007.819 1.826 1.826 1.826.387 0 .747-.122 1.043-.329a1.82 1.82 0 0 0 1.274.314c-.11.457-.522.798-1.013.798v1.565a2.61 2.61 0 0 0 2.609-2.609V6.783H12.65z"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#F0F0F0",
  d: "M10.824 11.478H8.477v1.565h2.347z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }